define('components/course/models/slide-type/text-image',[
    "components/course/models/slide-type/zeus-base",
    "components/course/models/text-image-component"
], function(BaseModel, TextImagComponentModel) {
    "use strict";

    /**
     * Model for Text Image slide
     * @extends BaseModel
     * @type Object
     * @constructor
     */
    return BaseModel.extend({

        /**
         * Stores the Text Image Component Model
         * @attribute textImageComponentModel
         * @type Object
         * @default null
         */
        "textImageComponentModel": null,

        /**
         * Sets defaults from model
         *
         * @method defaults
         * @private
         * @return {Object} Defaults if not set by user
         */
        "defaults": function() {
            var baseDefaults = BaseModel.prototype.defaults.apply(this, arguments),
                textImageDefaults = {

                    /**
                     * Stores the type of slide
                     * @attribute type
                     * @type String
                     * @default text-image
                     */
                    "type": "text-image",

                    /**
                     * Stores the data required by the slide
                     * @attribute data
                     * @type Object
                     */
                    "data": {

                        /**
                         * Stores the data of text image component
                         * @attribute textImageComponentModelData
                         * @type Object
                         * @default null
                         */
                        "textImageComponentModelData": null
                    }
                };

            return _.extend(baseDefaults, textImageDefaults);
        },

        /**
         * Initializes the model
         *
         * @method initialize
         * @private
         */
        "initialize": function() {
            this._populateData();
            this._createComponentModel();
        },

        "authoringJSONKey": function() {
            return _.extend(BaseModel.prototype.authoringJSONKey.call(this), {
                "data": {
                    "textImageComponentModelData": null,
                    "globalComponentData": null
                }
            });
        },

        "saveStateJSONKey": function() {
            return {}; // overrides zeus-base function.
        },

        /**
         * Populates the data of the model
         *
         * @method _populateData
         * @private
         */
        "_populateData": function() {
            if (!this.get('data')) {
                this.set('data', this.defaults().data);
            }
        },

        /**
         * Creates the Text Image Component Model
         *
         * @method _createComponentModel
         * @return {Object} Instance of view
         * @private
         */
        "_createComponentModel": function() {
            this.textImageComponentModel = new TextImagComponentModel(this.get('data').textImageComponentModelData || {});
            return this;
        }

    }, {
        "EVENTS": {
            "RETRIEVE_SAVE_STATE": "retrieve-save-state",
            "GET_SAVE_STATE": "get-save-state",
            "HIDE_ACC_TEXTAREA": "hide-acc-textarea"
        }
    });
});

